const faqs = [
  {
    q: '51吃瓜爆料网是什么？',
    a: '51吃瓜爆料网是一个专注网红吃瓜内容的聚合平台，汇集台北娜娜、玩偶姐姐、莫里秀等热门网红的实时动态、名场面合集与搞笑吃瓜短视频。我们提供轻量版播放体验，让你随时随地畅享吃瓜娱乐现场的精彩内容。',
  },
  {
    q: '内容多久更新一次？',
    a: '我们的编辑团队全天候追踪全网热点，每日更新超过200条吃瓜内容。无论是网红直播翻车还是最新热梗合集，都确保第一时间推送到你面前。',
  },
  {
    q: '什么是轻量版吃瓜短视频？',
    a: '51吃瓜轻量版是我们专为移动端优化的短视频格式，在保证画质清晰的前提下大幅降低流量消耗，让你在外也能流畅观看热播吃瓜短视频，不卡顿、不占空间。',
  },
  {
    q: '如何投稿或爆料？',
    a: '欢迎通过投稿爆料入口（页面#contact区域）提交你的独家吃瓜素材或网红最新动态。我们的编辑会及时审核并发布优质内容，一起让更多人看到有趣的吃瓜瞬间。',
  },
  {
    q: '51吃瓜爆料网是否收费？',
    a: '完全免费！51吃瓜爆料网所有内容均可免费浏览观看，无需注册登录。我们致力于为用户提供最便捷的吃瓜体验，没有任何隐藏收费。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          关于51吃瓜爆料网，你想知道的都在这里
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/80 p-5 md:p-6 cursor-pointer hover:border-primary-200 transition-all"
            >
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}